import { 
    ADMINISTRATIVEREPRESENTATIVE_BEGIN,
    ADMINISTRATIVEREPRESENTATIVE_ADD,
    ADMINISTRATIVEREPRESENTATIVE_FAILURE,
    ADMINISTRATIVEREPRESENTATIVE_CLEAR,

    ADMINISTRATIVEREPRESENTATIVE_FILTER_BEGIN,
    ADMINISTRATIVEREPRESENTATIVE_FILTER_SUCCESS,
    ADMINISTRATIVEREPRESENTATIVE_FILTER_FAILURE,
    ADMINISTRATIVEREPRESENTATIVE_FILTER_CLEAR

} from 'app/actions/AdministrativeRepresentativeActions';

const initialState = {
    allIds: [],
    filterData: [],
	isLoading: false,
};

export default function AdministrativeRepresentativeReducer (state = initialState, action) {
	switch (action.type) {
        case ADMINISTRATIVEREPRESENTATIVE_BEGIN: 
			return {
				...state,
				isLoading: true
			}
        case ADMINISTRATIVEREPRESENTATIVE_ADD:
			let allIds = action.payload.data.Data;
			
			return {
				...state,
				allIds,
				isLoading: false,
            };
        case ADMINISTRATIVEREPRESENTATIVE_CLEAR:
            return {
                ...state,
                allIds: [],
                isLoading: false,
            }
        case ADMINISTRATIVEREPRESENTATIVE_FAILURE: 
			return {
				...state,
				isLoading: false
            }
        case ADMINISTRATIVEREPRESENTATIVE_FILTER_BEGIN:
            return {
                ...state,
                isLoading: true
            }
        case ADMINISTRATIVEREPRESENTATIVE_FILTER_SUCCESS:
            let filterData = [...new Set(state.filterData.concat(action.payload.filterData))];
            return {
                ...state,
                filterData,
                isLoading: false,
            };
        case ADMINISTRATIVEREPRESENTATIVE_FILTER_CLEAR:
            return {
                ...state,
                filterData: [],
                isLoading: false,
            }
        case ADMINISTRATIVEREPRESENTATIVE_FILTER_FAILURE:
            return {
                ...state,
                isLoading: false
            }
		default:
			return state;
	}
};

export const getAdministrativeRepresentative = state => {
	return state.allIds;
}

export const getIsLoadingAdministrativeRepresentative = state => {
    return state.isLoading;
}

export const getAdministrativeRepresentativeFilter = state => {
    return state.filterData
}
export const getIsLoadingAdministrativeRepresentativeFilter = state => {
    return state.isLoading;
}